module.exports = __webpack_public_path__ + "static/chanterelles-zoom-a9ca5061da4925a90981e6799494b6c3.jpg";